import * as actions from './actions';

const initialState = {
	models: null,		// All the models
	model: null,	// The model fetched
	initial: {		// The initial state for model creation
		loading: false
	},
	error: false,
	errorDetail: null,
	loading: false,
	loadingModel: false,
	modelForEndpoint: null,
	generateSuccess: false,
	endpointLocation: null
};

//
// Sets model in state
//
function fetchModel(state) {
	return {
		...state,
		loadingModel: true,
		error: false
	};
}

function fetchModelSuccess(state, action) {
	return {
		...state,
		error: false,
		model: action.payload,
		loadingModel: false
	};
}

function fetchModelError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		model: null,
		loadingModel: false
	};
}

//
// Sets models in state
//
function fetchModels(state) {
	return {
		...state,
		loading: true,
		error: false
	};
}

function fetchModelsSuccess(state, action) {
	return {
		...state,
		error: false,
		models: action.payload,
		loading: false
	};
}

function fetchModelsError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false,
		models: {}
	};
}

//
// Saves model and updates models
//
function saveModel(state) {
	return {
		...state,
		loading: true,
		error: false
	};
}

function saveModelSuccess(state) {
	return {
		...state,
		error: false,
		loading: false
	};
}

function saveModelError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

//
// For generating flows/endpoints
//
function confirmGenerateEndpoints(state, action) {
	return {
		...state,
		modelForEndpoint: action.payload.modelForEndpoint,
		generateSuccess: false,
		endpointLocation: null
	};
}

function generateEndpoints(state) {
	return {
		...state
	};
}

function generateEndpointsStarted(state) {
	return {
		...state,
		modelForEndpoint: null,
		generateSuccess: false,
		endpointLocation: null
	};
}

function generateEndpointsSuccess(state, action) {
	return {
		...state,
		modelForEndpoint: null,
		generateSuccess: true,
		error: false,
		errorDetail: null,
		endpointLocation: action.payload.headers.location
	};
}

function generateEndpointsError(state, action) {
	return {
		...state,
		modelForEndpoint: null,
		error: true,
		errorDetail: action.payload,
		generateSuccess: false
	};
}

//
// Starts the new model flow
//
function designModel(state) {
	return {
		...state,
		error: false,
		initial: {
			...state.initial,
			loading: true
		}
	};
}

function designModelSuccess(state, action) {
	return {
		...state,
		error: false,
		errorDetail: null,
		initial: {
			...state.initial,
			...action.payload,
			loading: false
		}
	};
}

function designModelError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		initial: {
			loading: false,
			queryState: false
		}
	};
}

function designModelCancel(state) {
	return {
		...state,
		initial: {
			loading: false,
			queryState: false
		}
	};
}

function designModelInitState(state, action) {
	return {
		...state,
		initial: {
			...action.payload
		}
	};
}

export const models = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_MODEL:
			return fetchModel(state);
		case actions.FETCH_MODEL_SUCCESS:
			return fetchModelSuccess(state, action);
		case actions.FETCH_MODEL_ERROR:
			return fetchModelError(state, action);

		case actions.FETCH_MODELS:
			return fetchModels(state);
		case actions.FETCH_MODELS_SUCCESS:
			return fetchModelsSuccess(state, action);
		case actions.FETCH_MODELS_ERROR:
			return fetchModelsError(state, action);

		case actions.SAVE_MODEL:
			return saveModel(state);
		case actions.SAVE_MODEL_SUCCESS:
			return saveModelSuccess(state);
		case actions.SAVE_MODEL_ERROR:
			return saveModelError(state, action);

		case actions.DESIGN_MODEL:
			return designModel(state);
		case actions.DESIGN_MODEL_INIT_STATE:
			return designModelInitState(state, action);
		case actions.DESIGN_MODEL_SUCCESS:
			return designModelSuccess(state, action);
		case actions.DESIGN_MODEL_ERROR:
			return designModelError(state, action);
		case actions.DESIGN_MODEL_CANCEL:
			return designModelCancel(state);

		case actions.GENERATE_ENDPOINTS_CONFIRM:
			return confirmGenerateEndpoints(state, action);
		case actions.GENERATE_ENDPOINTS:
			return generateEndpoints(state);
		case actions.GENERATE_ENDPOINTS_STARTED:
			return generateEndpointsStarted(state);
		case actions.GENERATE_ENDPOINTS_SUCCESS:
			return generateEndpointsSuccess(state, action);
		case actions.GENERATE_ENDPOINTS_ERROR:
			return generateEndpointsError(state, action);
		default:
			return state;
	}
};
